import { render } from "./SalesIndex.vue?vue&type=template&id=bee612b2"
import script from "./SalesIndex.vue?vue&type=script&lang=js"
export * from "./SalesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__